module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAAACXBIWXMAAAsTAAALEwEAmpwYAAABF0lEQVQ4jb3UP0oDQRiG8V8kCIJITiCCqUQhN1AbsRE8gpWx9AQiBMTaUiy0ETs9gqBgm8oipJBUAUPwD4gKcS1cIchOdt0VH/hgmGEe3vmYmVKrF21jDxOyM8AZNvEyvFBq9aI3jOEUUQbZNJbj8RXW8DgsjOKJSsZ06zjHE6bQxAruxcnycoBD1HCDmaLCAepoYBbXmC9y5CTa5RzJOjhJmF9FNU/CEJdYLNLDRELCmq87GardkDDUw77kPn3T/K2wg40RwiChI8/hLqF2UnzPoYTvseAn/RThR0jYxlLK5kRCwiqORuw7jiuzcFz82ANUQgsh4W2KMMi/vZS8PPx5wjJeMYmLgq4FdEutXlTHvuLfVxdbn+GcTToWTTJaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/waterSystem/img/pump_selected.png
// module id = GhGp
// module chunks = 157